<template>
    <section>
        <b-field>
            <b-autocomplete
                    v-model="name"
                    :data="data"
                    placeholder="Поиск ноутбуков: К примеру: 8750H или Predator"
                    field="title"
                    :loading="isFetching"
                    icon="binoculars"
                    @input="getAsyncData"
                    @select="option => selected = option">
                <template slot-scope="props">
                    <router-link :to="'/categories/' + props.option.category.slug + '-' + props.option.category.id + '/' + props.option.id + '-' + props.option.slug">
                        <div class="media">
                            <div class="media-left">
                                <img width="45" :src="MEDIA_URL + props.option.images[0].url">
                            </div>
                            <div class="media-content">
                                {{ props.option.brand.name }}
                                {{ props.option.name }}
                                {{ props.option.model }}
                                <br>
                                <small>
<!--                                    Размер: {{props.option.screen_size.size}} дюмов<br />-->
<!--                                    ОЗУ: {{props.option.ram}} ГБ {{ props.option.ram_type.generation}}<br />-->
<!--                                    Процессор: {{ props.option.processor.brand.name }} {{props.option.processor.name}} {{props.option.processor.min_frequency}} - {{props.option.processor.max_frequency}} ГГц<br />-->
<!--                                    Память: {{ props.option.main_storage + props.option.secondary_storage}} ГБ <br />-->
                                </small>
                            </div>
                        </div>
                    </router-link>
                </template>
            </b-autocomplete>
        </b-field>
    </section>
</template>
<script>
    import debounce from 'debounce';
    import axios from 'axios'

    export default {
        name: "Search",
        data() {
            return {
                data: [],
                name: '',
                selected: null,
                isFetching: false,
                MEDIA_URL: process.env.VUE_APP_MEDIA_URL,
                API_URL: process.env.VUE_APP_API_URL,
                available_stock: 0,
            }
        },
        methods: {
            getAsyncData: debounce(function () {
                this.data = [];
                this.isFetching = true;
                axios.get(this.API_URL + '/products', {
                    params: {
                        search: this.name,
                        limit: 100,
                        quantity: this.available_stock
                    }
                })
                    .then(({data}) => {
                        data.results.forEach((item) => this.data.push(item));
                        this.isFetching = false
                    })
                    .catch((error) => {
                        this.isFetching = false;
                        throw error
                    })
            }, 700),
        },
    }
</script>
